/* istanbul ignore file */
import { ModelManager } from "@adobe/aem-spa-page-model-manager";
import { newrelic } from "@jti/fe-clients";
import "./react-components/ComponentsDeclaration";
import getAppInitialModel from "../src/app-related/getAppInitialModel";
import render from "../src/app-related/render";
import runInitialTenantConfiguration from "../src/app-related/runInitialTenantConfiguration";
newrelic.addRelease("loyalty", `${process.env.NEW_RELIC_VERSION}`);
document.addEventListener("DOMContentLoaded", () => {
    const initialModel = getAppInitialModel();
    runInitialTenantConfiguration();
    ModelManager.initialize().then((model) => {
        render(model, !!initialModel);
    });
});
